import React from "react";
import KeywordsTag from './KeywordsTag';

const City = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="cityPublic"
        handwritingSrc="../../content/handwriting/city.png"
        handwritingAlt="city"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default City;